module.exports = __webpack_public_path__ + "img/lang_java.e6d87e2d.svg";